module.exports = __webpack_public_path__ + "static/img/business_license.942d45b1.jpg";